import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Backdrop,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import api from "../../api/config";
import { AddAccessLevelToUser } from "../../api/Access";
import { useNotification } from "../../context/NotificationContext";

const Header = styled(DialogTitle)`
  background-color: #28929c;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px !important;
  background-color: #2b3342;
  color: white;
`;

export default function AddUserAccessModal({
  open,
  onClose,
  user = {},
  accesses = [],
  onSaveSuccess,
}) {
  const [email, setEmail] = useState(user.email || "");
  const [loading, setLoading] = useState(false);
  const [selectedAccess, setSelectedAccess] = useState({ name: "", uuid: "" });

  const { showNotification } = useNotification();

  useEffect(() => {
    console.log("User:", user);
    setEmail(user.email || "");

    setSelectedAccess({
      name: user.access_level || "",
      uuid: user.access_level_uuid || "",
    });
  }, [user, accesses]);

  const handleSave = async () => {
    if (!selectedAccess.name || !selectedAccess.uuid) {
      alert("Please select an access level before saving.");
      return;
    }
    setLoading(true);

    const payload = {
      email,
      accessLevelUID: selectedAccess.uuid,
    };

    try {
      const response = await api.post(`${AddAccessLevelToUser}`, payload);
      console.log("Add access level response:", response);
      onSaveSuccess();
    } catch (error) {
      console.error("Error updating user:", error);
      showNotification("Error updating user", "error");
    }
    setLoading(false);
  };

  const handleAccessChange = (event) => {
    const [name, uuid] = event.target.value.split("|");
    setSelectedAccess({ name, uuid });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Header>
        Add Access Level - {email}
        <IconButton onClick={onClose} style={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </Header>

      <Content>
        <FormControl component="fieldset">
          <FormLabel component="legend" style={{ color: "white" }}>
            Select Access Level
          </FormLabel>
          <RadioGroup
            value={`${selectedAccess.name}|${selectedAccess.uuid}`}
            onChange={handleAccessChange}
          >
            {accesses.map((access) => (
              <FormControlLabel
                key={access.uuid}
                value={`${access.name}|${access.uuid}`}
                control={<Radio style={{ color: "#28929c" }} />}
                label={
                  <div>
                    <strong>{access.name}</strong>
                    <br />
                    <span style={{ fontSize: "0.8em", color: "#ccc" }}>
                      {access.description || "No description provided."}
                    </span>
                  </div>
                }
                style={{ color: "white", marginTop: 15 }}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Content>

      <DialogActions sx={{ backgroundColor: "#28929c" }}>
        <Button onClick={handleSave} color="primary" variant="contained">
          Save
        </Button>
      </DialogActions>

      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}
